import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoomSelectors from '../../../../stores/rooms/rooms.selector';
import * as fromAttributesReducer from './attributes.reducer';
import * as fromAttributesState from './attributes.state';
import { AttributesState } from './attributes.state';

export const selectAttributesState = createFeatureSelector<AttributesState>(
  fromAttributesState.inRoomAttribuesFeatureKey
);

export const selectAttributesEntities = createSelector(
  selectAttributesState,
  fromAttributesReducer.selectAttributesEntities
);

export const selectCurentAttributes = createSelector(
  selectAttributesEntities,
  fromRoomSelectors.selectCurrentRoom,
  (entities, room) => (!!room && room.PmsReferenceCode ? entities[room.PmsReferenceCode] : undefined)
);
